import { createContext, useCallback, useContext, useEffect, useState } from "react";

// Сховище відповідей для режиму ДЗ (і перегляду ДЗ вчителем).
// Без провайдера (презентація на уроці) блоки працюють як раніше — стан живе лише в слайді.
export const AnswersContext = createContext(null);

// Стан блока, який переживає перегортання слайдів і відновлюється зі збережених відповідей
export function useSlideState(slideId, key, initial) {
  const ctx = useContext(AnswersContext);
  const [value, setValue] = useState(() => ctx?.values[slideId]?.[key] ?? initial);
  const update = useCallback(
    (next) =>
      setValue((prev) => {
        const resolved = typeof next === "function" ? next(prev) : next;
        ctx?.save(slideId, key, resolved);
        return resolved;
      }),
    [ctx, slideId, key]
  );
  return [value, update];
}

// Результат слайда: скільки правильно / всього / скільки відповідей дано
export function useReport(slideId, correct, total, answered) {
  const ctx = useContext(AnswersContext);
  useEffect(() => {
    ctx?.report(slideId, { correct, total, answered });
  }, [ctx, slideId, correct, total, answered]);
}

// Учитель дивиться здане ДЗ (лише перегляд): блоки показують історію спроб учня
export function useReviewMode() {
  const ctx = useContext(AnswersContext);
  return Boolean(ctx?.review);
}

// Додати неправильну спробу в історію (для ДЗ: учитель бачить, з якої спроби учень дійшов до відповіді)
export const addTry = (tries, key, value) => ({ ...tries, [key]: [...(tries[key] || []), value] });
